<template>
  <v-container class="ml-3 pt-0 pb-12">
    <div class="subtitle-1">{{ vString }}</div>
  </v-container>
</template>

<script>

export default {
  name: 'AppVersion',

  computed: {
    vString() {
      return `${process.env.VUE_APP_NAME}: v${process.env.VUE_APP_VERSION}`
    }
  }
}
</script>

<style>

</style>